import { Response } from '@marketplace-web/shared/api-client'

import { PrepareBumpOrderResp } from 'types/api/response/prepare-bump-order-resp'

import { transformBumpUpOrder } from 'data/transformers/bumps'

export const transformPrepareBumpOrderResponse = (response: Response<PrepareBumpOrderResp>) =>
  transformBumpUpOrder(response.push_up_order)
